import { request } from '@/utils/request'

export function getRegionListApi() {
  return request({
    url: `/region/list`,
    method: 'GET'
  })
}